"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YahooASPInstructions = exports.ICloudASPInstructions = exports.GmailASPInstructions = exports.AolASPInstructions = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var _Button = _interopRequireDefault(require("../Button"));
var _Text = require("./components/Text");
var _BrandLogo = _interopRequireDefault(require("./components/BrandLogo"));
var _Footer = _interopRequireDefault(require("./components/Footer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Layout = function Layout(_ref) {
  var logo = _ref.logo,
    title = _ref.title,
    description = _ref.description,
    footer = _ref.footer,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-screen-md"
  }, logo, /*#__PURE__*/_react["default"].createElement(_Text.Header, null, title), /*#__PURE__*/_react["default"].createElement(_Text.Description, null, description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-12 mb-24"
  }, _react["default"].Children.map(children, function (node, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "pb-12 last:pb-0"
    }, node);
  })), footer);
};
var InteractiveStep = function InteractiveStep(_ref2) {
  var order = _ref2.order,
    title = _ref2.title,
    link = _ref2.link,
    children = _ref2.children;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visited = _useState2[0],
    setVisited = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-2xl leading-loose"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-6 h-6 mr-4 flex items-center justify-center bg-primary rounded-full text-white"
  }, visited ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    fontSize: "small"
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm"
  }, order)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-dark"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "leading-snug font-light"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-xl mt-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex",
    onClick: function onClick() {
      return setVisited(true);
    }
  }, link)));
};
var Link = function Link(_ref3) {
  var to = _ref3.to,
    children = _ref3.children;
  if (!to) return null;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: to,
    target: "_blank",
    className: "text-primary",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, children, /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], {
    color: "inherit",
    className: "ml-2"
  })));
};
var GmailASPInstructions = exports.GmailASPInstructions = /*#__PURE__*/(0, _react.memo)(function (_ref4) {
  var onContinue = _ref4.onContinue;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var steps = [{
    title: t('retrofit.imap.instructions.gmail.step1.title'),
    description: t('retrofit.imap.instructions.gmail.step1.description'),
    link: t('retrofit.imap.instructions.gmail.step1.link'),
    linkContent: t('retrofit.imap.instructions.gmail.step1.action')
  }, {
    title: t('retrofit.imap.instructions.gmail.step2.title'),
    description: t('retrofit.imap.instructions.gmail.step2.description'),
    link: t('retrofit.imap.instructions.gmail.step2.link'),
    linkContent: t('retrofit.imap.instructions.gmail.step2.action')
  }, {
    title: t('retrofit.imap.instructions.gmail.step4.title'),
    description: t('retrofit.imap.instructions.gmail.step4.description'),
    link: t('retrofit.imap.instructions.gmail.step4.link'),
    linkContent: t('retrofit.imap.instructions.gmail.step4.action')
  }];
  return /*#__PURE__*/_react["default"].createElement(Layout, {
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "google"
    }),
    title: t('retrofit.imap.instructions.default.title'),
    description: t('retrofit.imap.instructions.gmail.description'),
    footer: /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
      link: t('gmailASPSite')
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "w-64",
      onClick: onContinue
    }, t('button.continue')))
  }, steps.map(function (_ref5, index) {
    var title = _ref5.title,
      link = _ref5.link,
      linkContent = _ref5.linkContent,
      description = _ref5.description;
    return /*#__PURE__*/_react["default"].createElement(InteractiveStep, {
      order: index + 1,
      title: title,
      link: /*#__PURE__*/_react["default"].createElement(Link, {
        to: link
      }, linkContent)
    }, description);
  }));
});
var ICloudASPInstructions = exports.ICloudASPInstructions = function ICloudASPInstructions(_ref6) {
  var onContinue = _ref6.onContinue;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var steps = [{
    title: t('retrofit.imap.instructions.default.step1.title'),
    description: t('retrofit.imap.instructions.icloud.step1.description'),
    link: t('retrofit.imap.instructions.icloud.step1.link'),
    linkContent: t('retrofit.imap.instructions.default.step1.action')
  }, {
    title: t('retrofit.imap.instructions.default.step2.title'),
    description: t('retrofit.imap.instructions.icloud.step2.description')
  }];
  return /*#__PURE__*/_react["default"].createElement(Layout, {
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "icloud"
    }),
    title: t('retrofit.imap.instructions.default.title'),
    description: t('retrofit.imap.instructions.icloud.description'),
    footer: /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
      link: t('icloudASPSite')
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "w-64",
      onClick: onContinue
    }, t('button.continue')))
  }, steps.map(function (_ref7, index) {
    var title = _ref7.title,
      description = _ref7.description,
      link = _ref7.link,
      linkContent = _ref7.linkContent;
    return /*#__PURE__*/_react["default"].createElement(InteractiveStep, {
      order: index + 1,
      title: title,
      link: /*#__PURE__*/_react["default"].createElement(Link, {
        to: link
      }, linkContent)
    }, description);
  }));
};
var YahooASPInstructions = exports.YahooASPInstructions = function YahooASPInstructions(_ref8) {
  var onContinue = _ref8.onContinue;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  var steps = [{
    title: t('retrofit.imap.instructions.default.step1.title'),
    description: t('retrofit.imap.instructions.yahoo.step1.description'),
    link: t('retrofit.imap.instructions.yahoo.step1.link'),
    linkContent: t('retrofit.imap.instructions.default.step1.action')
  }, {
    title: t('retrofit.imap.instructions.default.step2.title'),
    description: t('retrofit.imap.instructions.yahoo.step2.description')
  }];
  return /*#__PURE__*/_react["default"].createElement(Layout, {
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "yahoo"
    }),
    title: t('retrofit.imap.instructions.default.title'),
    description: t('retrofit.imap.instructions.yahoo.description'),
    footer: /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
      link: t('yahooASPSite')
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "w-64",
      onClick: onContinue
    }, t('button.continue')))
  }, steps.map(function (_ref9, index) {
    var title = _ref9.title,
      description = _ref9.description,
      link = _ref9.link,
      linkContent = _ref9.linkContent;
    return /*#__PURE__*/_react["default"].createElement(InteractiveStep, {
      order: index + 1,
      title: title,
      link: /*#__PURE__*/_react["default"].createElement(Link, {
        to: link
      }, linkContent)
    }, description);
  }));
};
var AolASPInstructions = exports.AolASPInstructions = function AolASPInstructions(_ref10) {
  var onContinue = _ref10.onContinue;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  var steps = [{
    title: t('retrofit.imap.instructions.default.step1.title'),
    description: t('retrofit.imap.instructions.aol.step1.description'),
    link: t('retrofit.imap.instructions.aol.step1.link'),
    linkContent: t('retrofit.imap.instructions.aol.step1.action')
  }, {
    title: t('retrofit.imap.instructions.default.step2.title'),
    description: t('retrofit.imap.instructions.aol.step2.description')
  }];
  return /*#__PURE__*/_react["default"].createElement(Layout, {
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "aol"
    }),
    title: t('retrofit.imap.instructions.default.title'),
    description: t('retrofit.imap.instructions.aol.description'),
    footer: /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
      link: t('aolASPSite')
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "w-64",
      onClick: onContinue
    }, t('button.continue')))
  }, steps.map(function (_ref11, index) {
    var title = _ref11.title,
      description = _ref11.description,
      link = _ref11.link,
      linkContent = _ref11.linkContent;
    return /*#__PURE__*/_react["default"].createElement(InteractiveStep, {
      order: index + 1,
      title: title,
      link: /*#__PURE__*/_react["default"].createElement(Link, {
        to: link
      }, linkContent)
    }, description);
  }));
};
//# sourceMappingURL=IMAPInstructions.js.map